import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.initGalleryAfterLoad(this)
  }

  disconnect() {
    if (this.inlineGallery) {
      this.inlineGallery.destroy()
      this.inlineGallery = null
    }
  }

  initGalleryAfterLoad = (event) => {
    // Initialize and launch the gallery automatically
    this.initAndLaunchGallery()
  }

  initAndLaunchGallery() {
    // Get all product photos to build the gallery items
    const galleryItems = this.buildGalleryItems()

    if (galleryItems.length > 0) {
      const lgContainer = document.getElementById('inline-gallery-container')
      if (lgContainer) {
        // Destroy any existing gallery instance
        if (this.inlineGallery) {
          this.inlineGallery.destroy()
        }

        // Initialize lightGallery with the collected items
        // Source: https://www.lightgalleryjs.com/docs/settings/
        this.inlineGallery = lightGallery(lgContainer, {
          container: lgContainer,
          dynamic: true,
          hash: false,
          closable: false,
          download: false,
          showMaximizeIcon: true,
          zoom: true,
          appendSubHtmlTo: '.lg-item',
          slideDelay: 200,
          plugins: [lgThumbnail, lgRotate, lgZoom],
          dynamicEl: galleryItems,
          rotate: true,
          rotateSpeed: 400,
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        })

        // Launch the gallery automatically
        this.inlineGallery.openGallery()
      }
    } else {
      console.log('No gallery items found to launch')
    }
  }

  buildGalleryItems() {
    // Find all hidden gallery items
    const galleryItems = []
    const photoElements = document.querySelectorAll('.gallery-item')

    photoElements.forEach(item => {
      const imgLink = item.querySelector('.img-link')
      const img = item.querySelector('img')
      const caption = item.querySelector('.img-caption')

      if (imgLink && img) {

        const galleryItem = {
          src: imgLink.getAttribute('href'),
          thumb: img.getAttribute('src'),
          responsive: img.getAttribute('src'),
          subHtml: img.getAttribute('alt') || ''
        }
        galleryItems.push(galleryItem)
      }
    })

    return galleryItems
  }
}
